import { Database } from "@vuex-orm/core"
import Dan from "@/models/Dan"
import User from "@/models/User"
import Album from "@/models/Album"
import Photo from "@/models/Photo"
import Video from "@/models/Video"
import Event from "@/models/Event"
import EventData from "@/models/EventData"

const database = new Database()

database.register(Dan)
database.register(User)
database.register(Album)
database.register(Photo)
database.register(Video)
database.register(Event)
database.register(EventData)

export default database
